import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, UserCircleIcon } from '@heroicons/react/solid';
import React, { Fragment } from 'react';
import { classNames } from 'lib/util';
import { Auth } from 'lib/auth';
import { MenuLink } from 'components/menu-link';
import { useGoogleUserIdFromParameter } from 'lib/useGoogleUserIdFromParameter';

export default function UserProfileMenu({ auth }: { auth: Auth }) {
  const googleUserId = useGoogleUserIdFromParameter();

  return (
    <Menu as="div" className="max-w-xs relative inline-block text-left">
      <div>
        <Menu.Button className="peer disabled:pointer-events-auto disabled:cursor-not-allowed disabled:opacity-40 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100">
          <div className="flex items-center w-full">
            <div className="flex-none">
              {auth?.state.user?.photoURL ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  className="h-8 w-8 rounded-full"
                  src={auth.state.user.photoURL}
                  alt=""
                />
              ) : (
                <UserCircleIcon className="h-8 w-8" />
              )}
            </div>
            <div className="ml-3 flex-1 min-w-0">
              <div className="pb-1 truncate text-base font-medium leading-none">
                {auth?.state.user?.displayName}
              </div>
              <div className="pb-1 truncate text-sm font-medium leading-none text-gray-500">
                {auth?.state.user?.email}
              </div>
            </div>
            <ChevronDownIcon
              className="-mr-1 ml-2 h-5 w-5"
              aria-hidden="true"
            />
          </div>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <MenuLink
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block w-full px-4 py-2 text-left text-sm'
                  )}
                  href="/profile"
                >
                  Settings
                </MenuLink>
              )}
            </Menu.Item>
            {!googleUserId && (
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="button"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block w-full px-4 py-2 text-left text-sm'
                    )}
                    onClick={() => auth.switchAccounts()}
                  >
                    Switch user
                  </button>
                )}
              </Menu.Item>
            )}
            <Menu.Item>
              {({ active }) => (
                <button
                  type="button"
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block w-full px-4 py-2 text-left text-sm'
                  )}
                  onClick={() => auth.signOut()}
                >
                  Sign out
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
